import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Creators as paymentActions } from '@/domain/useCases/procedures/lateExamen/activatePaymentLateCourses';
import { Creators as detailActions } from '@/domain/useCases/procedures/getStudentProcedureStatus';
import { Creators as cancelActions } from '@/domain/useCases/procedures/ChangeProgramCampusModality/cancelUseCase';
import LateExamenProgressView from './LateExamenProgressView';
import routes from '../../../../../../components/Routes/routingMap';

const LateExamProgressViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [
    isSuccessActivatePaymentExamStraggles,
    setisSuccessActivatePaymentExamStraggles
  ] = useState(false);

  const [showModalAnulateExamStraggles, setshowModalAnulateExamStraggles] =
    useState(false);

  const showConfirm = false;

  const { data: requestId } = useSelector(
    (state: any) => state.activatePaymentLateCourses
  );

  const {
    request,
    procedure,
    isLoading: isLoadingDetail
  } = useSelector((state: any) => state.procedureStudentStatus);

  useEffect(() => {
    if (!isLoadingDetail && !procedure) {
      history.push('/tramites');
    }
  }, [isLoadingDetail, procedure]);

  const handlerBackButton = () => {
    history.push('/tramites');
  };

  const handlerActivatePayment = () => {
    setisSuccessActivatePaymentExamStraggles(true);
    dispatch(paymentActions.activatePaymentCourses(request.id));
  };
  const handlerShowAnulate = () => {
    setshowModalAnulateExamStraggles(true);
  };

  const handlerCancelProcedure = () => {
    setshowModalAnulateExamStraggles(false);
    dispatch(cancelActions.cancelChangeProgramCampusModality(request.id, 1034));
    history.push('/tramites');
  };

  const handlerClose = () => {
    setshowModalAnulateExamStraggles(false);
  };

  useEffect(() => {
    if (requestId) {
      dispatch(detailActions.getStudentProcedureStatus(1034, requestId));
    }
  }, [requestId]);

  useEffect(() => {
    if (request?.status?.name === 'Procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.lateExamen.progress
        }${'?status=finalizado'}`
      );
    }
  }, [request]);

  return (
    <LateExamenProgressView
      handlerBackButton={handlerBackButton}
      isLoadingDetail={isLoadingDetail}
      showConfirm={showConfirm}
      procedure={procedure}
      request={request}
      handlerActivatePayment={handlerActivatePayment}
      handlerShowAnulate={handlerShowAnulate}
      isSuccessActivatePayment={isSuccessActivatePaymentExamStraggles}
      handlerCancelProcedure={handlerCancelProcedure}
      handlerClose={handlerClose}
      showModalAnulate={showModalAnulateExamStraggles}
    />
  );
};

export default LateExamProgressViewController;
